import { Spinner } from './index';

export class SpinnerWrapper {
	tableElement: HTMLElement | undefined = undefined;
	isSet = false;

	public refresh(element: HTMLElement) {
		if (this.isSet) {
			if (!this.tableElement) {
				this.show(element);
			}
		} else {
			this.hide();
		}
	}

	public show(element: HTMLElement | null | undefined) {
		this.isSet = true;
		if (!this.tableElement && element) {
			Spinner.show(element);
			this.tableElement = element;
		}
	}

	public hide() {
		this.isSet = false;
		if (this.tableElement) {
			Spinner.hide(this.tableElement);
			this.tableElement = undefined;
		}
	}
}
